import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import logo from "../assets/img/adn-logo.png";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (accounts.length > 0) {
      navigate("/");
    }
  }, [accounts, navigate]);

  const signIn = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  return (
    <>
      <img src={logo} alt="Logo Agence du Numérique" className="fixed top-3 left-3 w-52 h-auto" />
      <div className="flex flex-col justify-center items-center h-screen p-6 space-y-28">
        <h1 className="text-4xl font-bold text-center">
          Application de validation des marchés publics
        </h1>
        <button
          onClick={signIn}
          className="bg-gray-800 text-white py-4 pr-20 pl-9 rounded-full text-xl font-bold cursor-pointer flex items-center gap-7
          transition duration-300 ease-in-out hover:bg-gray-700 hover:scale-105"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="Microsoft Logo"
            className="w-8 h-auto"
          />
          Se connecter avec Microsoft
        </button>
      </div>
    </>
  );
}
